import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';

export const useHeaderState = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // 로컬 상태들
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const [profileManageModalOpen, setProfileManageModalOpen] = useState(false);
  
  // 계산된 상태들
  const profilePopoverOpen = Boolean(profileAnchorEl);
  const isAnalyzePage = location.pathname.includes('/analyze');

  return {
    // 번역 및 테마
    t,
    theme,
    
    // 반응형
    isMobile,
    
    // 페이지 상태
    isAnalyzePage,
    
    // 다이얼로그 상태
    logoutDialogOpen,
    setLogoutDialogOpen,
    
    // 프로필 메뉴 상태
    profileAnchorEl,
    setProfileAnchorEl,
    profilePopoverOpen,
    
    // 프로필 관리 모달 상태
    profileManageModalOpen,
    setProfileManageModalOpen
  };
}; 